<script setup>
import { pickTypes, displayModes } from '@/constants/calendar';

const props = defineProps({
  // all search filters
  modelValue: {
    type: Object,
    default: () => ({}),
  },

  displayMode: {
    type: String,
    default: displayModes.scroll,
    validator(displayMode) {
      return Object.values(displayModes).includes(displayMode);
    },
  },
  displayRangeMultiplier: {
    type: Number,
    default: 2,
  },
  rangeLock: {
    type: String,
    default: undefined,
  },
});
const emit = defineEmits(['update:modelValue']);

const pickType = computed(() =>
  props.modelValue.roundTrip ? pickTypes.range : pickTypes.single,
);

const modelData = computed({
  get() {
    const { roundTrip, departureDate, returnDate } = props.modelValue;

    return roundTrip ? [departureDate, returnDate] : departureDate;
  },
  set(date) {
    let emitData = {};

    if (props.modelValue.roundTrip) {
      const [departureDate, returnDate] = date;

      emitData = {
        departureDate,
        returnDate,
      };
    } else {
      emitData = {
        departureDate: date,
        returnDate: null,
      };
    }

    emit('update:modelValue', { ...props.modelValue, ...emitData });
  },
});

const isReturnSelecting = computed(() => {
  if (props.rangeLock === 'end') return true;
  else return props.modelValue.roundTrip && !modelData.value[1];
});
</script>

<template>
  <UiCalendar
    v-model="modelData"
    :pick-type="pickType"
    :display-mode="displayMode"
    :display-range-multiplier="displayRangeMultiplier"
    :range-lock="rangeLock"
    :is-return-selecting="isReturnSelecting"
  />
</template>
